import axios from 'axios';
import { Auth } from 'aws-amplify';
import * as qs from 'qs';
import fileDownload from 'js-file-download';

const UNAUTHORIZED = 401;

const client = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL,
    responseType: 'blob',
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config) => {
    return Auth.currentSession()
      .then((userSession) => {
        const idToken = userSession.getIdToken().getJwtToken();
        config.headers.Authorization = `Bearer ${ idToken }`;
        return config;
      })
      .catch((_err) => {
        config.headers.Authorization = 'Bearer ThisIsNotAToken';
        return config;
      });
  });

  // Add a response interceptor
  instance.interceptors.response.use((response) => {
    // Do something with response data
    return response;
  }, (err) => {
    // Do something with response error
    if (err.response && err.response.status === UNAUTHORIZED) {
      return Auth.signOut().finally(() => {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, '', '/');
      });
    }
    return Promise.reject(err);
  });

  return instance;
};

const c = client();

export const downloadTraitTemplate = (payload, fileName = 'download.docx') => {
  return c.post('template-demo-preview', payload)
    .then((response) => {
      return fileDownload(response.data, fileName);
    });
};

export const downloadThematicPackageTemplate = (payload, fileName = 'result.pdf') => {
  return c.post('report-demo-preview', payload)
    .then((response) => {
      return fileDownload(response.data, fileName);
    });
};

